import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineArrowUp,
} from "react-icons/ai";
import { FaLinkedinIn, FaReddit } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import VisitorCounter from "./VisitorCounter";

function Footer() {
  const [isVisible, setIsVisible] = useState(false);
  let date = new Date();
  let year = date.getFullYear();

  // Show/hide back to top button based on scroll position
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Container fluid className="footer">
        <Row>
          <Col md="4" className="footer-copywright">
            <h3>Designed and Developed by Sanjeet Pathak</h3>
          </Col>
          <Col md="4" className="footer-copywright">
            <h3>Copyright © {year} Sanjeet Pathak</h3>
          </Col>
          <Col md="4" className="footer-body">
            <ul className="footer-icons">
              <li className="social-icons">
                <a
                  href="https://github.com/Sanjeet990"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/sanjeet-pathak/"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.reddit.com/r/Astroluma/"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Reddit"
                >
                  <FaReddit />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:hello@sanjeetpathak.com"
                  aria-label="Email"
                >
                  <MdEmail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col>
            <VisitorCounter />
          </Col>
        </Row>
      </Container>
      <div 
        className={`back-to-top ${isVisible ? 'visible' : ''}`}
        onClick={scrollToTop}
        role="button"
        tabIndex={0}
        aria-label="Scroll to top"
      >
        <AiOutlineArrowUp />
      </div>
    </>
  );
}

export default Footer;
